import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { DirtyComponent } from 'src/app/core/components/errors/dirty-check.component';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { LabelViewComponent } from 'src/app/shared/label-view/label-view.component';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { forkJoin } from 'rxjs';
import { ValidationsDialogComponent } from 'src/app/core/components/validations-dialog/validations-dialog.component';
import { currencyValues, onBoarding } from 'src/app/utils/constants/strings';
import { ConfigService } from 'src/app/shared/services/config.service';
import { xmlToMessage } from 'src/app/modules/shipment/shipment-details/convertor';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { checkObjectExist, getCountryNameByCountryCode } from 'src/app/utils/utils';
import { basicSnackBarConfig } from '../../../utils/default-configs/configuration';
import {
  configurationIdMapForProductName,
  configurationIdMapForShipmentDetails,
  configurationIdMapForShipmentDetailsUpdate,
  configurationIdMapForShipmentDetailsUpdateEvent,
} from '../../../utils/constants/constant';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import { AddressService } from '../../address/service/address/address.service';
import { InvalidDialogComponent } from 'src/app/shared/errors/invalid-dialog/invalid-dialog.component';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { MawbService } from 'src/app/shared/services/mawb.service';
import { createConfigArray } from '../../../utils/default-configs/configuration';
import { UploadComponent } from '../../mapping/upload/upload.component';
import { DGPackage } from 'src/app/utils/constants/strings';
@Component({
  selector: 'app-shipment-details',
  templateUrl: './shipment-details.component.html',
  styleUrls: ['./shipment-details.component.scss'],
})
export class ShipmentDetailsComponent implements OnInit, DirtyComponent, AfterViewInit {
  shipmentManagement: FormGroup;
  userExportedInvoice: boolean = false;
  shipmentStatus: string = '';
  receiverCountryCodeChange: string = '';
  shipperCountryCodeChange: string = '';
  dgContentIds: any;
  shipmentData: any = {};
  shipperid;
  receiverid;
  sellerid;
  buyerid;
  additionalPartiesListFromShipment: any[] = [];
  s: string = '';
  isShipmentValueChanged = false;
  isDirty = false;
  currencyValues = currencyValues;
  shipmentUpdateAction: string = '';
  dbaddress_details = {
    shipperDetails: {},
    receiverDetails: {},
  };
  preAlertEmailsData: any;
  isPreAlertMsgDetailsUpdated: boolean;
  isShipPostalCodeCityValid: boolean;
  isRecPostalCodeCityValid: boolean;
  id;
  isRecPostalValidated: boolean = true;
  isShipPostalValidated: boolean = true;
  defaultShipperAddressId: any;
  postalLocationApiKeyNotSet: any;
  configOnBoarding = onBoarding;
  customerCredentialResponse: any;
  postalLocationApiKey: any;
  mydhlApiKey: any;
  mydhlApiPassword: any;
  decimalValue;
  pieceLevelLabelPrint: boolean;
  duplicatePieceRef: boolean;
  looseBbx: boolean;
  bbxWorkflow: any;
  mawbList = [];
  selectedMawbId: any;
  mawbId: string;
  @ViewChild('shipmentTabs') tabGroup: MatTabGroup;
  receiverCompleteDetails = {};
  responseLoaded: Promise<boolean>;
  shipmentStatusBefore: string;
  customDescriptions = [];
  DGContentFromConfig = [];
  tabIndex;
  shipmentDeclaredValue: any;
  disableLineItemCurr = false;
  currencyMismatch: boolean;
  isValidShipmentID: boolean = true;
  productNameValues: [];
  nonDocProductCodes = [];
  individualProductCodes = [];
  customsDeclarableValue;
  showLineItem: boolean = false;
  DGPackageData: any[];
  enumDGPackage = DGPackage;
  constructor(
    private shipmentService: ShipmentService,
    private addressService: AddressService,
    private _fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<any>,
    private route: ActivatedRoute,
    private errorDialogService: ErrorDialogService,
    private behaviorService: BehaviourService,
    private configService: ConfigService,
    private snackBarService: SnackBarService,
    private router: Router,
    private mawbService: MawbService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      shipmentId: string;
      shipperId: string;
      receiverId: string;
      action: string;
      shipmentTimeZone: string;
      configInvoices: string;
      tabName: number;
      status: string;
      looseBbx: boolean;
      decimalValue: number;
    }
  ) {
    this.decimalValue = data.decimalValue;
    // this.getDecimalUnitPrice();
  }

  ngOnInit(): void {
    this.checkPostalApiKeySet();
    this.userExportedInvoice = sessionStorage.getItem('isCustomInvoice') === 'Custom';
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForProductName))
      .then(response => {
        if (response && response[0]?.data) {
          this.individualProductCodes = response[0]?.data
            .filter(item => item?.showLineItem === true)
            .map(item => item?.productCode);
          if (this.userExportedInvoice) {
            this.nonDocProductCodes = response[0]?.data
              .filter(item => item?.showLineItem === true)
              .map(item => item?.productCode);
            this.showLineItem = false;
          } else {
            this.nonDocProductCodes = response[0]?.data
              .filter(item => item?.docType === 'NON-DOC')
              .map(item => item?.productCode);
            this.showLineItem = true;
          }
        }
      });
    this.behaviorService?.currentMessage?.subscribe((data: any) => {
      if (data?.type === 'productCode') {
        const isNonDOc = this.nonDocProductCodes.some(item => item.includes(data?.value));
        this.customsDeclarableValue = this.individualProductCodes.some(item =>
          item.includes(data?.value)
        );
        if (isNonDOc) {
          this.showLineItem = true;
        } else {
          this.showLineItem = false;
          (this.shipmentManagement.get('invoiceDetails')?.get('lineItems') as FormArray).clear();
        }
      }
    });
    this.formValidation();
    // this.shipmentDetailsFromList();
    this.looseBbx = this.data?.looseBbx ? this.data.looseBbx : false;
    this.getPiecesConfig();
    this.getProductNameData();
    this.getShipmentDeclaredValue();
    this.getLineItemCurrencyStatus();
  }

  getDefaultShipperAddress() {
    this.configService.fetchConfig('default_shipper_address').then(response => {
      if (response && response.data && response.data[0].address_id) {
        this.defaultShipperAddressId = response.data[0].address_id;
        this.shipmentManagement.patchValue({ shipper_id: this.defaultShipperAddressId });
        this.getAddressData();
      }
    });
  }

  onStatusTabChange(event) {
    this.tabIndex = event?.index;
    this.shipmentManagement.markAllAsTouched();
  }

  formValidation() {
    this.shipmentManagement = this._fb.group({
      //shipmentID: '',
      status: '',
      seller_id: '',
      buyer_id: '',
      receiver_id: '',
      shipper_id: '',
      shipmentDate: new FormControl(null, Validators.compose([Validators.required])),
      productCode: new FormControl(
        '',
        Validators.compose([
          // Validators.maxLength(1),
          // Validators.minLength(1),
          // Validators.pattern('^[AB]+$'),
        ])
      ),
      localProductCode: new FormControl(
        '',
        Validators.compose([
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('B'),
        ])
      ),
      shipperAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9)])
      ),
      payerAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9)])
      ),
      dutyAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.minLength(9), Validators.maxLength(9)])
      ),
      shipperReference: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(35)])
      ),
      shipmentID: new FormControl(
        '',
        Validators.compose([Validators.minLength(10), Validators.maxLength(10)])
      ),
      shipmentContentsDescription: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(70)])
      ),
      DTPServiceFlag: new FormControl(
        'N',
        Validators.compose([
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('[YN]'),
        ])
      ),
      NDSServiceFlag: new FormControl(
        'N',
        Validators.compose([
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('[YN]'),
        ])
      ),
      DGContentID: [],
      DGPackageData: [],
      PLTServiceFlag: new FormControl(
        'N',
        Validators.compose([
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('[YN]'),
        ])
      ),
      noOfPieces: '',
      isCustomsDeclarable: new FormControl(
        'N',
        Validators.compose([
          Validators.required,
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('[YN]'),
        ])
      ),
      shipmentDeclaredValue: new FormControl(
        '',
        Validators.compose([
          Validators.min(0.01),
          Validators.pattern('^[0-9]+(.[0-9]{0,' + this.decimalValue + '})?$'),
        ])
      ),
      shipmentDeclaredValueCurrency: new FormControl(
        '',
        Validators.compose([Validators.minLength(3), Validators.maxLength(3)])
      ),
      shipperDetails: this._fb.group({
        shipperCompanyName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(60)])
        ),
        shipperNickName: '',
        shipperContactPersonName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(45)])
        ),
        shipperAddressLine1: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(45)])
        ),
        shipperAddressLine2: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        shipperAddressLine3: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        shipperCityName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(35)])
        ),
        shipperCountryName: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        shipperPostalCode: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(12)])
        ),
        shipperCountryCode: new FormControl(
          { value: '', disabled: true },
          Validators.compose([
            Validators.required,
            Validators.maxLength(2),
            Validators.minLength(2),
          ])
        ),
        shipperProvinceCode: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(35)])
        ),
        shipperEmail: new FormControl(
          '',
          Validators.compose([Validators.maxLength(50), Validators.email])
        ),
        shipperPhone: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(1),
            Validators.maxLength(25),
            Validators.pattern('[- +()0-9]+'),
          ])
        ),
        shipperMobilePhone: new FormControl('', Validators.compose([])),
        shipperProvinceName: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(35)])
        ),
        shippersuburb: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(45)])
        ),
      }),

      receiverDetails: this._fb.group({
        receiverCompanyName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(60)])
        ),
        receiverNickName: '',
        receiverContactPersonName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(45)])
        ),
        receiverAddressLine1: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(45)])
        ),
        receiverAddressLine2: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        receiverAddressLine3: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        receiverCityName: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(35)])
        ),
        receiverCountryName: new FormControl('', Validators.compose([Validators.maxLength(45)])),
        receiverPostalCode: new FormControl(
          '',
          Validators.compose([Validators.required, Validators.maxLength(12)])
        ),
        receiverCountryCode: new FormControl(
          { value: '', disabled: true },
          Validators.compose([
            Validators.required,
            Validators.maxLength(2),
            Validators.minLength(2),
          ])
        ),
        receiverProvinceCode: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(35)])
        ),
        receiverEmail: new FormControl(
          '',
          Validators.compose([Validators.maxLength(50), Validators.email])
        ),
        receiverPhone: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(1),
            Validators.maxLength(25),
            Validators.pattern('[- +()0-9]+'),
          ])
        ),
        receiverMobilePhone: new FormControl('', Validators.compose([])),
        receiverProvinceName: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(35)])
        ),
        receiversuburb: new FormControl(
          '',
          Validators.compose([Validators.minLength(1), Validators.maxLength(45)])
        ),
      }),
      preAlertEmails: this._fb.array([]),
      shipmentNotification: new FormControl(false),
      invoiceDetails: this._fb.group({
        additionalParties: new FormControl(''),
        iossNumber: new FormControl(''),
        iossIssuerCountryCode: new FormControl(''),
        invoiceReferenceNumber: new FormControl(''),
        invoiceNumber: new FormControl(''),
        invoiceDate: new FormControl(null),
        invoiceExportReason: new FormControl('', Validators.compose([Validators.maxLength(30)])),
        invoiceIncoterm: new FormControl(''),
        invoiceUnitOfMeasurement: new FormControl(''),
        placeOfIncoterm: '',
        noOfLineItem: new FormControl(
          1,
          Validators.compose([Validators.min(1), Validators.max(999)])
        ),
        lineItems: this._fb.array([]),
      }),

      pieces: this._fb.array([]),
      DGCustomDescription: new FormControl([]),
    });
  }

  shipmentDetailsFromList() {
    if (this.data) {
      this.id = this.data?.shipmentId;
      this.shipmentUpdateAction = this.data?.action;

      if (this.data?.configInvoices === 'Custom') {
        this.userExportedInvoice = true;
      }
      if (this.id) {
        this.getShipment();
      }
      if (this.shipmentUpdateAction === 'create') {
        this.getDefaultShipperAddress();
        this.getDefaultConfiguration();
        this.shipmentManagement.patchValue({ shipmentDate: moment(new Date(), 'YYYY-MM-DD') });
        this.shipmentManagement.controls.invoiceDetails.patchValue({
          invoiceDate: moment(new Date(), 'YYYY-MM-DD'),
        });
        this.shipmentManagement.controls.shipperReference.enable();
      } else {
        this.getDGContentIDs();
        this.getDGContentData();
      }
    }
    if (this.data?.status == 'Draft') {
      this.shipmentManagement.controls.shipperReference.enable();
    } else if (this.data?.status && this.data?.status !== 'Validation failed') {
      this.shipmentManagement.controls.shipmentID.disable();
    }
  }

  getDefaultConfiguration() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForShipmentDetails))
      .then(response => {
        response.forEach(item => {
          this.patchValueToFormsInShipmentDetails(item?.config_id, item?.data);
        });
      });
  }

  getDGContentIDs() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForShipmentDetailsUpdate))
      .then(response => {
        this.dgContentIds = response[0]?.data;
      });
  }

  getDGContentData() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForShipmentDetailsUpdateEvent))
      .then(response => {
        this.setDGContentCustomDescriptionValue(response[0]?.data[0]);
      });
  }

  setDGContentCustomDescriptionValue(data: any) {
    if (data?.DGContentID.length > 0) {
      this.DGContentFromConfig = data.DGContentID;
      this.DGContentFromConfig?.includes('HU5') || this.DGContentFromConfig?.includes('E01')
        ? (this.customDescriptions = data?.customDescription)
        : (this.customDescriptions = []);
    }
  }

  getDecimalUnitPrice() {
    this.configService.fetchConfig('unitPriceDecimalPoints').then(response => {
      this.decimalValue = parseInt(response.data[0].unitPriceDecimalPoints);
    });
  }

  patchValueToFormsInShipmentDetails(formName, formData) {
    const formConfigs = {
      default: () => ``,
      baby_accountnumbers: () => {
        const accoundata: any = {};
        accoundata.shipperAccountNumber = formData.find(
          obj => obj.name === 'shipperAccountNumber'
        )?.number;
        accoundata.payerAccountNumber = formData.find(
          obj => obj.name === 'payerAccountNumber'
        )?.number;
        if (formData.length > 2) {
          accoundata.dutyAccountNumber = formData.find(
            obj => obj.name === 'dutyAccountNumber'
          )?.number;
        }

        this.shipmentManagement.patchValue(accoundata);
      },
      default_unitofmeasurement: () => {
        this.shipmentManagement.controls.invoiceDetails.patchValue({
          invoiceUnitOfMeasurement: formData[0]?.invoiceUnitOfMeasurement,
        });
      },
      mother_incoterm: () => {
        this.shipmentManagement.controls.invoiceDetails.patchValue({
          invoiceIncoterm: formData[0]?.value,
        });
      },
      mother_exportdeclarationdetails: () => {
        this.shipmentManagement.controls.invoiceDetails.patchValue({
          placeOfIncoterm: formData[0]?.content.exportDeclaration.invoice.placeOfIncoterm,
        });
      },
      default_currency: () => {
        this.shipmentManagement.patchValue({
          shipmentDeclaredValueCurrency: formData[0]?.declaredValueCurrency,
        });
      },
      global_servicecodes: () => (this.dgContentIds = formData),
      baby_default_options: () => {
        this.shipmentManagement.patchValue({
          productCode: formData[0]?.productCode,
          localProductCode: formData[0]?.localProductCode,
          DGContentID: [],
          DGPackageData: [],
          isCustomsDeclarable: formData[0]?.isCustomsDeclarable,
        });
        this.setDGContentCustomDescriptionValue(formData[0]);
      },
      default_shipment_content: () => {
        this.shipmentManagement.patchValue({
          shipmentContentsDescription: formData[0]?.shipmentContentsDescription,
        });
      },
    };
    return (formConfigs[formName] || formConfigs.default)();
  }

  canDeactivate() {
    return this.isDirty;
  }

  private addLineItemGroup(): FormGroup {
    return this._fb.group({
      lineItemNumber: new FormControl(
        { value: '', disabled: true },
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.min(1),
          Validators.max(999),
        ])
      ),
      lineItemDescription: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(170)])
      ),
      lineItemUnitPrice: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.00001),
          Validators.pattern('^[0-9]+(.[0-9]{0,' + this.decimalValue + '})?$'),
        ])
      ),
      lineItemUnitPriceCurrency: new FormControl(
        { value: '', disabled: this.disableLineItemCurr },
        Validators.compose([Validators.required])
      ),
      lineItemQuantity: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')])
      ),
      lineItemQuantityUnitofMeasurement: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),

      lineItemPartNumber: new FormControl(''),
      lineItemReference: new FormControl(''),
      lineItemExportCommodityCode: new FormControl(''),
      lineItemImportCommodityCode: new FormControl(''),
      lineItemExportReasonType: new FormControl('', Validators.compose([Validators.required])),
      lineItemManufactureCountry: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(2)])
      ),
      lineItemNetWeight: new FormControl(
        0.1,
        Validators.compose([
          Validators.required,
          Validators.min(0.001),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
      lineItemGrossWeight: new FormControl(
        0.1,
        Validators.compose([
          Validators.required,
          Validators.min(0.001),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
    });
  }

  newPreAlertMsg(): FormGroup {
    return this._fb.group({
      typeCode: 'email',
      receiverId: '',
      bespokeMessage: '',
    });
  }

  private addPieceGroup(): FormGroup {
    return this._fb.group({
      pieceNo: new FormControl({ value: '', disabled: true }),
      packagingType: new FormControl(''),
      packageWeight: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('^[0-9]+(.[0-9]{0,3})?$')])
      ),
      packageLength: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('^[0-9]+(.[0-9]{0,3})?$')])
      ),
      packageWidth: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('^[0-9]+(.[0-9]{0,3})?$')])
      ),
      packageHeight: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('^[0-9]+(.[0-9]{0,3})?$')])
      ),
      pieceReference: new FormControl(
        '',
        !this.pieceLevelLabelPrint
          ? Validators.compose([])
          : Validators.compose([Validators.required])
      ),
      pieceID: new FormControl({ value: '', disabled: true }),
      pieceContentDescription: new FormControl(''),
      status: new FormControl({ value: '', disabled: true }),
      volumetricWeight: new FormControl({ value: '', disabled: true }),
    });
  }

  formatDateValue(dateValue) {
    const year = dateValue.substring(0, 4);
    const month = dateValue.substring(4, 6);
    const day = dateValue.substring(6, 8);
    return month + '/' + day + '/' + year;
  }

  dateInput(dateValue: any) {
    const date = new Date(dateValue);
    const day = ('0' + (date.getMonth() + 1)).slice(-2),
      mnth = ('0' + date.getDate()).slice(-2);
    return date.getFullYear() + '' + day + '' + mnth;
  }

  getShipment() {
    this.shipmentService.getShipment(this.id).subscribe((response: any) => {
      this.shipmentStatus = response?.status;
      this.updateShipmentFormData(response);
      this.mapShipperReceiverToForm(response);
      this.isShipmentValueChanged = false;
      this.isDirty = false;
      const pieceTab = this.userExportedInvoice ? 1 : 2;
      if (this.pieceLevelLabelPrint && this.shipmentStatus && this.tabGroup) {
        this.tabGroup.selectedIndex = pieceTab;
      } else {
        this.tabGroup.selectedIndex = 0;
      }
      this.mawbId = response?.mawbId ? response.mawbId : undefined;
      const callLBXMother = response?.productCode === 'A' || response?.productCode === 'B';
      if (this.looseBbx && callLBXMother && this.shipmentStatus != 'Manifested') {
        this.getMawbList(this.id, this.mawbId);
      }
    });
  }

  mapShipperReceiverToForm(response) {
    this.shipperid = response?.shipper_id;
    this.receiverid = response?.receiver_id;
    this.sellerid = response?.seller_id;
    this.buyerid = response?.buyer_id;
    if (response.status !== 'Draft') {
      //&& this.receiverid
      if (this.shipperid) {
        this.getAddressData(response);
      }
    } else {
      this.getAddressData(response);
    }
  }

  updateShipmentFormData(data) {
    this.shipmentData = data;

    this.setActiveTab();
    if (this.shipmentData?.DGContentID && this.shipmentData?.DGContentID.length === 0) {
      data.DGContentID = [];
      data.DGPackageData = [];
    }
    // this.shipmentData?.DGContentID &&
    //   this.shipmentData?.DGContentID.length === 0 &&
    //   (data.DGContentID = []);
    const isNonDOc = this.nonDocProductCodes.some(item =>
      item.includes(this.shipmentData.productCode)
    );
    if (isNonDOc) {
      this.showLineItem = true;
    } else {
      this.showLineItem = false;
      (this.shipmentManagement.get('invoiceDetails')?.get('lineItems') as FormArray).clear();
    }
    this.shipmentManagement.patchValue(data);
    this.DGPackageData = data.DGPackageData || [];
    this.shipmentManagement.patchValue({
      DGContentID: data.DGContentID ? data.DGContentID : [],
      DGCustomDescription: data.DGCustomDescription ? data.DGCustomDescription[0] : [],
      DGPackageData: this.DGPackageData,
    });

    const lineItemData = this.shipmentData.invoiceDetails?.lineItems;
    (this.shipmentManagement.get('invoiceDetails')?.get('lineItems') as FormArray).clear();
    if (lineItemData && lineItemData.length > 0) {
      lineItemData.forEach(lineItem => {
        const lineItemGrp = this.addLineItemGroup();
        if (!lineItem?.lineItemGrossWeight) {
          lineItem.lineItemGrossWeight = 0.1;
        }
        if (!lineItem?.lineItemNetWeight) {
          lineItem.lineItemNetWeight = 0.1;
        }
        lineItemGrp.patchValue(lineItem);
        (this.shipmentManagement.get('invoiceDetails')?.get('lineItems') as FormArray).push(
          lineItemGrp
        );
        if (
          (this.shipmentManagement.get('invoiceDetails').get('lineItems') as FormArray).controls
            .length > 0
        ) {
          this.disableLineItemCurr = true;
          const lineItemsFormArray = this.shipmentManagement
            .get('invoiceDetails')
            .get('lineItems') as FormArray;
          lineItemsFormArray.at(0).get('lineItemUnitPriceCurrency').enable();
        }
      });
    }
    const pieceData = this.shipmentData.pieces;
    (this.shipmentManagement.get('pieces') as FormArray).clear();
    if (pieceData.length > 0) {
      pieceData.forEach(piece => {
        const pieceGrp = this.addPieceGroup();
        const volWeightVal =
          (piece.packageLength * piece.packageWidth * piece.packageHeight) / 5000;
        piece.volumetricWeight = volWeightVal;
        pieceGrp.patchValue(piece);
        (this.shipmentManagement.get('pieces') as FormArray).push(pieceGrp);
      });
    }

    if (this.shipmentData.shipmentDate) {
      const currentShipmentDate = new Date(this.shipmentData?.shipmentDate).toISOString();
      this.shipmentManagement.patchValue({ shipmentDate: currentShipmentDate.split('T')[0] });
    } else {
      this.shipmentManagement.patchValue({ shipmentDate: moment(new Date(), 'YYYY-MM-DD') });
    }

    if (this.shipmentData?.invoiceDetails?.invoiceDate) {
      const currentInvoiceDate = new Date(
        this.shipmentData?.invoiceDetails?.invoiceDate
      ).toISOString();
      this.shipmentManagement.controls.invoiceDetails.patchValue({
        invoiceDate: currentInvoiceDate.split('T')[0],
      });
    } else {
      this.shipmentManagement.controls.invoiceDetails.patchValue({
        invoiceDate: moment(new Date(), 'YYYY-MM-DD'),
      });
    }

    if (
      (this.shipmentData.invoiceDetails?.noOfLineItem === 0 && this.userExportedInvoice) ||
      !isNonDOc
    ) {
      this.shipmentManagement.controls.invoiceDetails.patchValue({
        noOfLineItem: 1,
      });
    }

    this.shipmentManagement.markAllAsTouched();
    this.disableForm();
  }

  updateShipment(action) {
    this.shipmentUpdateAction = action;

    if (
      this.shipmentData?.mawb &&
      !(this.shipmentData.status === 'Manifested' || this.shipmentData.status === 'Manifest Failed')
    ) {
      this.errorDialogService.openDialog(
        'alert.shipmentAlreadyLinked',
        true,
        this.shipmentData.mawb
      );
    } else {
      (action == 'update' || action == 'print') &&
      ((this.pieceLevelLabelPrint == true && this.checkPieceLabelGenerated() == true) ||
        (this.pieceLevelLabelPrint == false && this.data.tabName == 1))
        ? this.pieceIdChangeAlert(action, this.pieceLevelLabelPrint)
        : this.updateAddressandShipment(action);
    }
  }

  updateAddressandShipment(action) {
    const shipment = this.shipmentManagement?.getRawValue();
    //TODO : Patch country name with respect ot county code
    // compareAddress returns true if both address are same
    const shipperDetailsUpdated = !this.compareAddress(
      shipment?.shipperDetails,
      this.dbaddress_details?.shipperDetails ?? {}
    );
    const receiverDetailsUpdated = !this.compareAddress(
      shipment?.receiverDetails,
      this.dbaddress_details?.receiverDetails ?? {}
    );

    const createAddressRequestArray = [];

    if (shipperDetailsUpdated) {
      const request_data = this.getRequestData(shipment, 'shipper');

      if (checkObjectExist(request_data.address_details, 'shipperPostalCode')) {
        request_data.address_details.shipperPostalCode =
          request_data.address_details.shipperPostalCode.trim();
      }

      if (checkObjectExist(request_data.address_details, 'shipperCityName')) {
        request_data.address_details.shipperCityName = request_data.address_details.shipperCityName
          .trim()
          .toUpperCase();
      }

      if (checkObjectExist(request_data.address_details, 'shipperCountryName')) {
        request_data.address_details.shipperCountryName =
          request_data.address_details.shipperCountryName.trim().toUpperCase();
      }

      createAddressRequestArray.push(this.addressService.createAddress(request_data));
    }
    if (receiverDetailsUpdated) {
      const request_data = this.getRequestData(shipment, 'receiver');

      if (checkObjectExist(request_data.address_details, 'receiverCityName')) {
        request_data.address_details.receiverCityName =
          request_data.address_details.receiverCityName.trim().toUpperCase();
      }

      if (checkObjectExist(request_data.address_details, 'receiverPostalCode')) {
        request_data.address_details.receiverPostalCode =
          request_data.address_details.receiverPostalCode.trim();
      }

      if (checkObjectExist(request_data.address_details, 'receiverCountryName')) {
        request_data.address_details.receiverCountryName =
          request_data.address_details.receiverCountryName.trim().toUpperCase();
      }

      createAddressRequestArray.push(this.addressService.createAddress(request_data));
    }

    if (createAddressRequestArray.length == 0) {
      this.updateShipmentDetails(action);
    } else {
      forkJoin(createAddressRequestArray).subscribe({
        next: (address_details: any) => {
          const newShipper: any = address_details.find(
            address => address.address_type == 'SHIPPER'
          );
          const newReceiver: any = address_details.find(
            address => address.address_type == 'RECEIVER'
          );

          if (newShipper) {
            this.shipmentManagement.get('shipper_id')?.setValue(newShipper.address_id);
          }
          if (newReceiver) {
            this.shipmentManagement.get('receiver_id')?.setValue(newReceiver.address_id);
          }
          this.updateShipmentDetails(action);
        },
      });
    }
  }

  async updateShipmentDetails(action) {
    let customDescValue = [];
    if (typeof this.shipmentManagement.get('DGCustomDescription').value == 'object') {
      customDescValue = [];
    } else {
      if (this.shipmentManagement.get('DGCustomDescription').value) {
        customDescValue = [this.shipmentManagement.get('DGCustomDescription').value];
      }
    }

    this.shipmentManagement.patchValue({
      noOfPieces: (this.shipmentManagement.get('pieces') as FormArray).length,
      DGCustomDescription: customDescValue,
    });

    this.shipmentManagement.patchValue({
      isCustomsDeclarable:
        this.customsDeclarableValue || this.shipmentManagement.get('productCode').value === 'P'
          ? 'Y'
          : 'N',
    });

    this.shipmentManagement.patchValue({
      noOfLineItem: (this.shipmentManagement.get('invoiceDetails')?.get('lineItems') as FormArray)
        .length,
    });

    const shipment = this.shipmentManagement.getRawValue();
    shipment.shipmentDate = moment(shipment.shipmentDate).format('YYYY-MM-DD');
    shipment.invoiceDetails.invoiceDate = moment(shipment.invoiceDetails.invoiceDate).format(
      'YYYY-MM-DD'
    );

    if (
      this.individualProductCodes.some(item =>
        item.includes(this.shipmentManagement.get('productCode')?.value)
      )
    ) {
      delete shipment.localProductCode;
    }

    delete shipment.shipperDetails;

    let isSaveAddress = await this.configService.fetchConfig('save_reciever_address');
    isSaveAddress = isSaveAddress?.data[0];
    if (isSaveAddress || isSaveAddress == null) {
      delete shipment.receiverDetails;
    }

    delete shipment.preAlertEmails;
    delete shipment.shipmentNotification;

    if (shipment.pieces.length > 0) {
      shipment.pieces.forEach(piece => {
        delete piece.volumetricWeight;
      });
    }

    //check for DGPackage DryIce and Biological Substance
    let hasDGPackage = shipment.DGContentID.filter(
      d =>
        d == this.enumDGPackage.DryIce.toString() ||
        d == this.enumDGPackage.BiologicalSubstance.toString()
    );
    if (hasDGPackage) {
      const noDryIce =
        shipment.DGPackageData.filter(d => d.contentId == this.enumDGPackage.DryIce.toString())
          .length == 0;
      const noBiological =
        shipment.DGPackageData.filter(
          d => d.contentId == this.enumDGPackage.BiologicalSubstance.toString()
        ).length == 0;

      if (noDryIce) {
        const idx = shipment.DGContentID.indexOf(this.enumDGPackage.DryIce.toString());
        if (idx > -1) shipment.DGContentID.splice(idx, 1);
      }

      if (noBiological) {
        const idx = shipment.DGContentID.indexOf(this.enumDGPackage.BiologicalSubstance.toString());
        if (idx > -1) shipment.DGContentID.splice(idx, 1);
      }
    }

    this.shipmentUpdate(action, shipment);
  }

  shipmentUpdate(action, shipment) {
    if (this.mydhlApiKey == '' || this.mydhlApiPassword == '' || this.postalLocationApiKey == '') {
      const msg = 'Please set all Customer Credentials to proceed';
      this.openCustomerCredentialNav(msg);
    } else {
      if (!shipment?.payerAccountNumber || !shipment?.shipperAccountNumber) {
        this.getPayerAccountConfig(action, shipment);
      } else {
        this.shipmentUpdateData(action, shipment);
      }
    }
  }

  shipmentUpdateData(action, shipment) {
    switch (action) {
      case 'create':
        shipment.invoiceDetails.invoiceDate = null;

        const isDraft = shipment.status === 'Draft';
        // if (!isDraft) {
        //   delete shipment.shipmentID;
        // }
        const serviceFunction = isDraft ? 'updateShipment' : 'createShipment';
        shipment.status = '';
        this.shipmentService[serviceFunction](shipment).subscribe((response: any) => {
          if (response?.shipmentID) {
            this.dialogRef.close({ data: response });
          }
        });
        break;
      case 'update':
        this.shipmentService.updateShipment(shipment).subscribe({
          next: data => {
            this.shipperid = data.shipper_id;
            this.receiverid = data.receiver_id;
            this.getAddressData(data);
            this.updateShipmentFormData(data);
            this.shipmentManagement.markAsDirty();
            this.isShipmentValueChanged = false;
            this.isDirty = false;
            this.snackBarService.createSnackBar(
              basicSnackBarConfig.addressComponentUpdate?.message,
              basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
              basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
              basicSnackBarConfig.addressComponentUpdate?.duration
            );
            if (data && data.shipmentID) {
              this.dialogRef.close({ data: data });
            }
          },
        });
        break;
      case 'print':
        this.shipmentService.updateShipment(shipment).subscribe({
          next: data => {
            this.shipperid = data.shipper_id;
            this.receiverid = data.receiver_id;
            this.getAddressData(data);
            this.updateShipmentFormData(data);
            this.shipmentManagement.markAsDirty();
            this.isShipmentValueChanged = false;
            this.isDirty = false;
            this.snackBarService.createSnackBar(
              basicSnackBarConfig.addressComponentUpdate?.message,
              basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
              basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
              basicSnackBarConfig.addressComponentUpdate?.duration
            );
            this.generateLabel();
            // data?.shipmentID && this.dialogRef.close({ data: data });
          },
        });
        break;
      case 'remanifest':
        this.shipmentService.updateShipment(shipment).subscribe({
          next: data => {
            this.shipperid = data.shipper_id;
            this.receiverid = data.receiver_id;
            this.getAddressData(data);
            this.updateShipmentFormData(data);
            this.shipmentManagement.markAsDirty();
            this.isShipmentValueChanged = false;
            this.isDirty = false;
            this.snackBarService.createSnackBar(
              basicSnackBarConfig.addressComponentUpdate?.message,
              basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
              basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
              basicSnackBarConfig.addressComponentUpdate?.duration
            );
            data.productCode === 'B' || data.productCode === 'A'
              ? this.manifestBabyshipment()
              : this.manifestIndividualBabyshipment(
                  'remanifest',
                  this.shipmentData.productCode
                ).subscribe(res => this.handleManifestResponse(res));
          },
        });
        break;
      case 'draft':
        shipment.status = 'Draft';
        shipment.invoiceDetails.invoiceDate = null;
        // delete shipment.shipmentID;
        if (shipment?.shipmentID) {
          this.shipmentService.updateShipment(shipment).subscribe({
            next: data => {
              this.shipperid = data.shipper_id;
              this.receiverid = data.receiver_id;
              this.getAddressData(data);
              this.updateShipmentFormData(data);
              this.shipmentManagement.markAsDirty();
              this.isShipmentValueChanged = false;
              this.isDirty = false;
              this.snackBarService.createSnackBar(
                basicSnackBarConfig.addressComponentUpdate?.message,
                basicSnackBarConfig.addressComponentUpdate?.horizontalPosition,
                basicSnackBarConfig.addressComponentUpdate?.verticalPosition,
                basicSnackBarConfig.addressComponentUpdate?.duration
              );
              if (data?.shipmentID) {
                this.dialogRef.close({ data: data });
              }
            },
          });
        } else {
          this.shipmentService.createShipment(shipment).subscribe((response: any) => {
            if (response?.shipmentID) {
              this.dialogRef.close({ data: response });
            }
          });
        }
        break;
    }
  }

  //TODO: Make this component as single error bad coding
  openDialogErrors(errors) {
    this.dialog.open(ValidationsDialogComponent, {
      data: {
        message: errors,
      },
    });
  }

  compareAddress(new_address, old_address) {
    const new_address_keys = Object.keys(new_address);
    const old_address_keys = Object.keys(old_address);
    const added_keys = new_address_keys.filter(key => !old_address_keys?.includes(key));
    added_keys.forEach(key => {
      if (!new_address[key]) {
        delete new_address[key];
      }
    });
    return this.compareObjects(new_address, old_address);
  }

  compareObjects(obj1, obj2) {
    const obj1_keys = Object.keys(obj1);
    const obj2_keys = Object.keys(obj2);
    if (obj1_keys?.length === obj2_keys?.length) {
      return obj1_keys?.every(
        key =>
          obj2_keys?.indexOf(key) != -1 &&
          String(obj2[key])?.toLowerCase() === String(obj1[key])?.toLowerCase()
      );
    }
    return false;
  }

  getRequestData(details, address_type) {
    let addressDetailsData;
    if (address_type === 'receiver') {
      addressDetailsData = { ...details.receiverDetails };
    } else {
      addressDetailsData = { ...details.shipperDetails };
    }
    for (const key in addressDetailsData) {
      if (typeof addressDetailsData[key] === 'string') {
        addressDetailsData[key] = addressDetailsData[key].trim();
      }
    }
    const request_data = {
      address_type: address_type.toUpperCase(),
      address_details: addressDetailsData,
      shipmentNotification: details.shipmentNotification,
      preAlertEmails: details.preAlertEmails,
    };

    if (address_type === 'shipper') {
      delete request_data.shipmentNotification;
      delete request_data.preAlertEmails;
    }

    delete request_data.address_details[`${address_type}NickName`];

    return request_data;
  }

  printLabel(isIndividualShip) {
    if (isIndividualShip) {
      this.shipmentService
        .getIndividuaShiplabel('individualShipmentID', this.shipmentData.shipmentID)
        .subscribe({
          next: data => {
            this.shipmentService.labelWindowPrint(data.label);
          },
        });
    } else {
      this.shipmentService.getLabel('shipmentID', this.shipmentData.shipmentID).subscribe({
        next: data => {
          this.shipmentService.labelWindowPrint(data.label);
        },
      });
    }
  }

  generateLabel() {
    if (this.checkDhlApiKeySet()) {
      const msg = 'alert.myDhlApiCred';
      this.openCustomerCredentialNav(msg);
    } else {
      const workflow = sessionStorage.getItem('loose-bbx');
      if (this.shipmentData.productCode === 'B' || this.shipmentData.productCode === 'A') {
        if (workflow === 'Yes' && !this.shipmentData.mawbId) {
          this.errorDialogService.openDialog('alert.selectMawbSid', false);
          return;
        }
      }
      if (this.shipmentData.productCode === 'B' || this.shipmentData.productCode === 'A') {
        this.shipmentService.generateLabel(this.shipmentData.shipmentID).subscribe({
          next: ({ body, status }) => {
            if (status == 202) {
              this.errorDialogService.openDialog(
                xmlToMessage(body) ? xmlToMessage(body) : 'alert.labelNotGenerated'
              );
            } else {
              this.getShipment();
              this.isShipmentValueChanged = false;
              this.printLabel(false);
              this.behaviorService.sendEvent('labelGenerated');
            }
          },
        });
      } else {
        this.manifestIndividualBabyshipment('manifest', this.shipmentData.productCode).subscribe(
          res => this.handleManifestResponse(res)
        );
      }
    }
  }

  disableForm() {
    const bbxuserrole = sessionStorage.getItem('bbx-role');
    if (this.shipmentData.status === 'Manifested') {
      this.shipmentManagement.disable();
      this.disableUpdate();
    }
    if (
      this.shipmentData.status === 'Manifest Failed' &&
      !(bbxuserrole === 'COUNTRY_IT_ADMIN' || bbxuserrole === 'GLOBAL_ADMIN')
    ) {
      this.shipmentManagement.disable();
      this.disableUpdate();
    } else if (this.shipmentData.status === 'Manifest Failed') {
      this.shipmentManagement.controls.productCode.disable();
    }
    if (this.shipmentData.status === 'Label Generated') {
      this.shipmentManagement.markAsPristine();
      this.isShipmentValueChanged = this.isDirty = false;
    }
  }

  mapCountryWithCode(responseData) {
    if (responseData?.shipperDetails?.shipperCountryCode) {
      this.shipmentManagement.controls.shipperDetails.patchValue({
        shipperCountryName: getCountryNameByCountryCode(
          responseData.shipperDetails?.shipperCountryCode
        )?.name,
      });

      this.shipperCountryCodeChange = responseData.receiverDetails?.shipperCountryCode;
    }
    if (responseData?.receiverDetails?.receiverCountryCode) {
      this.shipmentManagement.controls.receiverDetails.patchValue({
        receiverCountryName: getCountryNameByCountryCode(
          responseData.receiverDetails?.receiverCountryCode
        )?.name,
      });

      this.receiverCountryCodeChange = responseData.receiverDetails?.receiverCountryCode;
    }
  }

  async getAddressData(response = null) {
    let requestData: any;
    if (this.shipmentUpdateAction === 'create' && this.defaultShipperAddressId) {
      requestData = {
        query: {
          address_id: [this.defaultShipperAddressId],
        },
      };
    } else {
      requestData = {
        query: {
          address_id: [
            this.shipperid ? this.shipperid : '',
            this.receiverid ? this.receiverid : '',
            this.sellerid ? this.sellerid : '',
            this.buyerid ? this.buyerid : '',
          ],
        },
      };
    }

    let isSaveAddress = await this.configService.fetchConfig('save_reciever_address');
    isSaveAddress = isSaveAddress?.data[0];

    this.addressService.getAddressList(requestData).subscribe({
      next: data => {
        const sellerDetails = data.data.find(add => add.address_type == 'SELLER');
        const buyerDetails = data.data.find(add => add.address_type == 'BUYER');
        if (sellerDetails) {
          const seller = sellerDetails.address_details;
          this.additionalPartiesListFromShipment.push({
            address_id: sellerDetails.address_id,
            addressType: sellerDetails.address_type,
            contactPersonName: seller.sellerContactPersonName,
            companyName: seller.sellerCompanyName,
            addressLine1: seller.sellerAddressLine1,
            city: seller.sellerCityName,
            postalCode: seller.sellerPostalCode,
            CountryName: seller.sellerCountryName,
          });
        }
        if (buyerDetails) {
          const buyer = buyerDetails.address_details;
          this.additionalPartiesListFromShipment.push({
            address_id: buyerDetails.address_id,
            addressType: buyerDetails.address_type,
            contactPersonName: buyer.buyerContactPersonName,
            companyName: buyer.buyerCompanyName,
            addressLine1: buyer.buyerAddressLine1,
            city: buyer.buyerCityName,
            postalCode: buyer.buyerPostalCode,
            CountryName: buyer.buyerCountryName,
          });
        }

        this.dbaddress_details.shipperDetails = data.data.find(
          add => add.address_type == 'SHIPPER'
        )?.address_details;

        this.isShipPostalValidated = data.data.find(
          add => add.address_type == 'SHIPPER'
        )?.address_validated;

        this.shipmentManagement.controls.shipperDetails.patchValue(
          this.dbaddress_details.shipperDetails
        );

        if (this.shipmentUpdateAction !== 'create') {
          if (isSaveAddress || isSaveAddress == null) {
            this.dbaddress_details.receiverDetails = data.data.find(
              add => add.address_type == 'RECEIVER'
            )?.address_details;

            this.isRecPostalValidated = data.data.find(
              add => add.address_type == 'RECEIVER'
            )?.address_validated;

            this.receiverCompleteDetails = !response?.receiverDetails
              ? data.data.find(add => add.address_type == 'RECEIVER')
              : response.receiverDetails;

            this.shipmentManagement.controls.receiverDetails.patchValue(
              this.dbaddress_details.receiverDetails
            );

            this.preAlertEmailsData = data.data.find(
              add => add.address_type == 'RECEIVER'
            )?.preAlertEmails;

            const shipmentNotificationData = data.data.find(
              add => add.address_type == 'RECEIVER'
            )?.shipmentNotification;

            if (this.preAlertEmailsData != undefined && this.preAlertEmailsData.length > 0) {
              (this.shipmentManagement.get('preAlertEmails') as FormArray).clear();
              if (this.preAlertEmailsData.length > 0) {
                this.preAlertEmailsData.forEach(alertMsg => {
                  const alertMsgGrp = this.newPreAlertMsg();
                  alertMsgGrp.patchValue(alertMsg);
                  (this.shipmentManagement.get('preAlertEmails') as FormArray).push(alertMsgGrp);
                });
              }
            }

            this.shipmentManagement.controls.shipmentNotification.patchValue(
              shipmentNotificationData
            );
          } else {
            this.receiverCompleteDetails = response.receiverDetails;
          }
        }

        //TODO : Not needed need to test later
        this.mapCountryWithCode(this.dbaddress_details);

        this.isShipmentValueChanged = false;
        this.isDirty = false;
      },
    });
  }

  disableUpdate() {
    return (
      this.shipmentManagement.valid &&
      this.shipmentManagement.dirty &&
      this.isPostalCodeVerified() &&
      this.isShipmentValueChanged &&
      this.shipmentData.status != 'User Input Required' &&
      this.shipmentData.status != 'Validation failed' &&
      this.checkUserExportedInvoice() &&
      this.duplicatePieceRef == false &&
      this.isValidShipmentID &&
      !this.currencyMismatch
    );
  }

  disableSave() {
    return (
      this.shipmentManagement.valid &&
      this.shipmentManagement.dirty &&
      this.isPostalCodeVerified() &&
      this.isShipmentValueChanged &&
      this.shipmentData.status != 'User Input Required' &&
      this.checkUserExportedInvoice() &&
      this.duplicatePieceRef == false &&
      this.isValidShipmentID &&
      !this.currencyMismatch
    );
  }

  disableUpdate1() {
    const bbxuserrole = sessionStorage.getItem('bbx-role');
    if (
      this.shipmentData.status === 'Manifest Failed' &&
      (bbxuserrole === 'COUNTRY_IT_ADMIN' || bbxuserrole === 'GLOBAL_ADMIN')
    ) {
      return true;
    } else
      return (
        this.shipmentManagement.valid &&
        this.shipmentManagement.dirty &&
        this.isPostalCodeVerified() &&
        this.isValidShipmentID &&
        this.isShipmentValueChanged &&
        this.shipmentData.status != 'User Input Required' &&
        this.checkUserExportedInvoice() &&
        this.duplicatePieceRef == false
      );
  }

  checkUserExportedInvoice() {
    if (!this.userExportedInvoice && this.showLineItem) {
      return this.checkPiecesEmpty() && this.checkLineItemsEmpty();
    } else {
      return this.checkPiecesEmpty();
    }
  }

  disablePrintButton() {
    return (
      (this.shipmentData.status === 'Label Generated' ||
        this.shipmentData.status === 'Manifest Failed' ||
        this.shipmentData.status === 'Manifested') &&
      (this.shipmentData.status === 'A' || this.shipmentData.status === 'B')
    );
  }

  disableCreate() {
    return (
      (this.shipmentManagement.valid &&
        this.shipmentManagement.dirty &&
        this.isPostalCodeVerified() &&
        this.isValidShipmentID &&
        this.isShipmentValueChanged &&
        this.checkUserExportedInvoice() &&
        this.duplicatePieceRef == false &&
        !this.currencyMismatch) ||
      this.shipmentData.status === 'Draft'
    );
  }

  isShipmentValid() {
    return !(
      this.shipmentManagement.valid ||
      this.shipmentData.status === 'Manifested' ||
      this.shipmentData.status === 'Manifest Failed'
    );
  }

  checkPiecesEmpty() {
    return this.shipmentManagement.value.pieces.length > 0;
  }

  checkLineItemsEmpty() {
    return this.shipmentManagement.value.invoiceDetails?.lineItems?.length > 0;
  }

  disableCreateLabel() {
    return (
      this.shipmentManagement.valid &&
      this.isPostalCodeVerified() &&
      this.isValidShipmentID &&
      this.shipmentData.status !== 'User Input Required' &&
      (!this.isShipmentValueChanged || this.shipmentManagement.pristine) &&
      this.shipmentData.status !== 'Label Generated' &&
      this.shipmentData.status !== 'Validation failed' &&
      this.shipmentData.status !== 'Draft' &&
      this.checkUserExportedInvoice()
    );
  }

  disablePrintViewLabel() {
    return (
      this.shipmentData.status === 'Label Generated' ||
      this.shipmentData.status === 'Manifested' ||
      (this.shipmentData.status === 'Manifest Failed' &&
        ['A', 'B'].includes(this.shipmentData.productCode))
    );
  }

  viewLabel() {
    if (this.shipmentData.productCode === 'B' || this.shipmentData.productCode === 'A') {
      this.shipmentService.getLabel('shipmentID', this.shipmentData.shipmentID).subscribe({
        next: data => {
          this.openPrintView(data.label, data.shipmentID);
        },
      });
    } else {
      this.shipmentService
        .getIndividuaShiplabel('individualShipmentID', this.shipmentData.shipmentID)
        .subscribe({
          next: data => {
            this.openPrintView(data.label, data.shipmentID);
          },
        });
    }
  }

  openPrintView(value, shipmentId) {
    const dialogRef = this.dialog.open(LabelViewComponent, {
      data: {
        label: value,
        labelName: '',
        // labelName: `DHL_BBX_Label_${
        //   this.shipmentManagement.get('shipperReference').value
        // }_${shipmentId}`,
        shipmentId: shipmentId,
        format: 'pdf',
      },
      maxHeight: '90vh',
      maxWidth: '50vw',
    });

    dialogRef.afterClosed().subscribe(() => ``);
  }

  ngAfterViewInit() {
    this.isShipmentValueUnChanged();
  }

  isShipmentValueUnChanged() {
    this.shipmentManagement.valueChanges.subscribe(() => {
      this.isDirty = true;
      this.isShipmentValueChanged = true;
    });
  }

  setActiveTab() {
    if (this.shipmentData.status == 'User Input Required') {
      this.tabGroup.selectedIndex = 5;
    }
  }

  showStatusfromShip($event) {
    this.isShipPostalCodeCityValid = $event;
  }

  showStatusfromRec($event) {
    this.isRecPostalCodeCityValid = $event;
  }

  isPostalCodeVerified() {
    return this.isShipPostalCodeCityValid && this.isRecPostalCodeCityValid;
  }

  checkPostalApiKeySet() {
    this.configService.fetchConfig('customer_credential').then(response => {
      this.customerCredentialResponse = response;

      if (response && response.data) {
        this.postalLocationApiKey =
          response && Object.keys(response).length != 0 && response.data[0]?.postalLocationApiKey
            ? response.data[0].postalLocationApiKey
            : '';

        this.mydhlApiKey =
          response && Object.keys(response).length != 0 && response.data[0]?.mydhlApiKey
            ? response.data[0].mydhlApiKey
            : '';

        this.mydhlApiPassword =
          response && Object.keys(response).length != 0 && response.data[0]?.mydhlApiPassword
            ? response.data[0].mydhlApiPassword
            : '';

        const message = 'Please set Postal Location Api key to proceed';
        // (Object.keys(response[0]).length === 0 || response[0]?.data[0]?.postalLocationApiKey=='' || response[0]?.data[0]?.postalLocationApiKey==null)

        this.postalLocationApiKey == ''
          ? this.openCustomerCredentialNav(message)
          : this.shipmentDetailsFromList();
      } else {
        this.shipmentDetailsFromList();
      }
    });
  }
  openCustomerCredentialNav(msg) {
    const dialogRef = this.dialog.open(InvalidDialogComponent, {
      data: {
        message: msg,
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      this.dialog.closeAll();
      if (res == 'true') {
        this.behaviorService.sendEvent(res);
        this.router.navigateByUrl('/customer-onboarding');
      }
    });
  }
  checkDhlApiKeySet() {
    return this.mydhlApiKey == '' || this.mydhlApiPassword == '' ? true : false;
  }

  openSetDhlCredentialNav() {
    const dialogRef = this.dialog.open(InvalidDialogComponent, {
      data: {
        message: 'alert.selectDhlApi',
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      this.dialog.closeAll();
      if (res == 'true') {
        this.behaviorService.sendEvent(res);
        this.router.navigateByUrl('/customer-onboarding');
      }
    });
  }

  getPiecesConfig() {
    this.configService.fetchConfig('label_print_config').then(response => {
      this.pieceLevelLabelPrint = response.data[0].printPieceLevel === 'Yes';

      this.responseLoaded = Promise.resolve(true);

      if (
        this.pieceLevelLabelPrint &&
        this.shipmentData.status !== undefined &&
        this.tabGroup !== undefined
      ) {
        this.tabGroup.selectedIndex = 3;
      } else if (this.tabGroup) {
        this.tabGroup.selectedIndex = 0;
      }
    });
  }

  checkPieceLabelGenerated() {
    return this.shipmentData.pieces.some(
      item => item.status.toLowerCase() == 'Generated'.toLowerCase()
    );
  }
  updateForm(data) {
    this.id = data;
    this.getShipment();
  }

  updatePieces(data) {
    if (data) {
      (this.shipmentManagement.get('invoiceDetails').get('lineItems') as FormArray).markAsDirty();
      (this.shipmentManagement.get('pieces') as FormArray).markAsDirty();
    }
  }

  pieceIdChangeAlert(action, pieceLevelLabelPrint) {
    const msg1: string = 'alert.updateShipment';
    const msg2: string = 'alert.updateShipmentLabel';

    const dailogData = {
      message: pieceLevelLabelPrint == true ? msg1 : msg2,
    };
    if (action != 'print' && this.shipmentData.status != 'Manifest Failed') {
      const alertDialog = this.dialog.open(AlertComponent, {
        data: dailogData,
      });
      alertDialog.afterClosed().subscribe(res => {
        if (res == 'true') {
          this.updateAddressandShipment(action);
        } else {
        }
      });
    } else {
      this.updateAddressandShipment(action);
    }
  }
  disableUpdatePiecRef(data) {
    this.duplicatePieceRef = data && this.pieceLevelLabelPrint;
  }

  getWorkflowConfig() {
    this.configService.fetchConfig('loose_bbx').then(response => {
      this.bbxWorkflow = response.data[0];
      this.looseBbx = this.bbxWorkflow === 'Yes' ? true : false;

      // this.looseBbx && this.getMawbList(this.id);
    });
  }

  getMawbList(shipmentId, mawbId) {
    const data = {
      shipmentID: shipmentId,
    };
    this.shipmentService.getMawbList(data).subscribe({
      next: (response: any) => {
        this.mawbList = response?.message ? response.message : [];
        // mawbId != undefined ? (this.selectedMawbId = mawbId) : '';
        this.selectedMawbId = mawbId;
        // this.dropDownDisabled =
      },
    });
  }

  linkShipments(mawbId) {
    const data = {
      mawb: mawbId,
      shipmentIds: [this.id],
    };
    this.mawbService.lbbxMotherLink(data).subscribe(() => {
      this.getShipment();
      this.isShipmentValueChanged = false;
      this.behaviorService.sendEvent('labelGenerated');
    });
  }

  checkShipmentStatus() {
    this.selectedMawbId = this.mawbId;
    return this.shipmentStatus == 'Created' ? false : true;
  }
  lbbxLinkedCheck() {
    return (
      this.looseBbx &&
      (this.shipmentData.status == 'Label Generated' ||
        this.shipmentData.status == 'Manifested' ||
        this.shipmentData.status == 'Manifest Failed') &&
      this.mawbList.length > 0
    );
  }
  checkMawbSelected() {
    return this.looseBbx && this.shipmentData.status == 'Created' && this.selectedMawbId == '';
  }
  manifestBabyshipment() {
    const data = {
      shipmentIDs: [this.id],
      type: 'Manual Re-Manifest',
    };
    this.shipmentService.babyManifest(data).subscribe((response: any) => {
      if (response && response?.message) {
        this.snackBarService.createSnackBar(
          basicSnackBarConfig.remanifestSuccess?.message,
          basicSnackBarConfig.remanifestSuccess?.horizontalPosition,
          basicSnackBarConfig.remanifestSuccess?.verticalPosition,
          basicSnackBarConfig.addressComponentUpdate?.duration
        );
        this.dialogRef.close({ data: 'remanifest' });
      }
      this.getShipment();
    });
  }
  remanifestBaby() {
    const bbxuserrole = sessionStorage.getItem('bbx-role');

    const isAdmin = bbxuserrole === 'COUNTRY_IT_ADMIN' || bbxuserrole === 'GLOBAL_ADMIN';

    const isManifestFailed = this.shipmentData.status === 'Manifest Failed';

    const isBabyProduct =
      this.shipmentData.productCode === 'B' || this.shipmentData.productCode === 'A';

    if (isManifestFailed && isAdmin) {
      this.updateShipment('remanifest');
    } else if (isBabyProduct) {
      this.manifestBabyshipment();
    } else {
      this.manifestIndividualBabyshipment('remanifest', this.shipmentData.productCode).subscribe(
        res => this.handleManifestResponse(res)
      );
    }
  }

  getPayerAccountConfig(action, shipment) {
    this.configService.fetchConfig('baby_accountnumbers').then(response => {
      shipment.payerAccountNumber = response?.data?.find(
        item => item.name == 'payerAccountNumber'
      )?.number;
      shipment.shipperAccountNumber = response?.data?.find(
        item => item.name == 'shipperAccountNumber'
      )?.number;
      if (response[0]?.data?.length > 2) {
        shipment.dutyAccountNumber = response?.data?.find(
          item => item.name == 'dutyAccountNumber'
        )?.number;
      }
      this.shipmentUpdateData(action, shipment);
    });
  }

  getShipmentDeclaredValue() {
    this.behaviorService?.currentMessage?.subscribe((data: any) => {
      if (data?.type === 'receiver') {
        if (data?.calculate) {
          this.shipmentDeclaredValue = this.calculateShipmentDeclaredValue(data) || '';
        } else {
          this.shipmentDeclaredValue = '';
        }
      } else {
        this.shipmentDeclaredValue = this.calculateShipmentDeclaredValue(data) || '';
      }
    });
  }
  calculateShipmentDeclaredValue(data) {
    let shipmentDeclaredValue = 0;
    const isNonDOc = this.nonDocProductCodes.some(item =>
      item.includes(this.shipmentManagement.get('productCode').value)
    );
    if (
      data?.lineItems?.length > 0 &&
      (this.shipmentManagement.get('receiverDetails').get('receiverCountryCode').value === 'US' ||
        isNonDOc)
    ) {
      data?.lineItems?.forEach(element => {
        if (element.lineItemUnitPrice && element.lineItemQuantity) {
          shipmentDeclaredValue += element?.lineItemUnitPrice * element?.lineItemQuantity;
        }
      });
    }
    return parseFloat(shipmentDeclaredValue.toFixed(this.decimalValue));
  }

  getLineItemCurrencyStatus() {
    this.behaviorService?.currentMessage?.subscribe((data: any) => {
      if (typeof data == 'boolean') {
        if (data === true) {
          this.currencyMismatch = true;
        } else {
          this.currencyMismatch = false;
        }
      }
    });
  }

  showStatusforShipID($event) {
    this.isValidShipmentID = $event;
  }

  manifestIndividualBabyshipment(isManifest, productCode) {
    const data =
      isManifest === 'manifest'
        ? {
            shipmentID: this.id,
            productCode: productCode,
          }
        : {
            shipmentID: this.id,
            type: 'Manual Re-Manifest',
            productCode: productCode,
          };

    return this.shipmentService.individualBabyManifest(data);
  }

  handleManifestResponse(response: any) {
    const isSuccess = response?.error?.length == 0;

    if (isSuccess) {
      this.snackBarService.createSnackBar(
        basicSnackBarConfig.remanifestSuccess?.message,
        basicSnackBarConfig.remanifestSuccess?.horizontalPosition,
        basicSnackBarConfig.remanifestSuccess?.verticalPosition,
        basicSnackBarConfig.addressComponentUpdate?.duration
      );

      this.dialogRef.close({ data: 'remanifest' });
    }
    this.getShipment();
    if (isSuccess) {
      this.printLabel(true);
    }
  }

  getProductNameData() {
    let babyDefaultProductCode;
    this.shipmentManagement.get('productCode')?.valueChanges.subscribe(val => {
      this.configService
        .fetchConfig('baby_default_options')
        .then(response => {
          babyDefaultProductCode = response?.data[0]?.productCode;

          return this.configService.getConfigs(createConfigArray(configurationIdMapForProductName));
        })
        .then(response => {
          this.productNameValues = response[0]?.data.filter(
            item =>
              item.setConfig === true ||
              item.productCode === val ||
              item.productCode === babyDefaultProductCode
          );
        });
    });
  }

  openUploadInvoices(shipmentID, motherStatus) {
    if (motherStatus === 'Manifested') {
      motherStatus = 'Closed';
    }
    const dialogRef = this.dialog.open(UploadComponent, {
      autoFocus: false,
      width: '75vw',
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        isOpeningFrom: 'uploadInvoice',
        shipmentID,
        motherStatus,
      },
    });
    dialogRef.afterClosed().subscribe(() => ``);
  }

  printInvoice(shipmentID) {
    this.shipmentService.getShipmentInvoice(shipmentID).subscribe({
      next: data => {
        this.shipmentService.labelWindowPrint(data.label);
      },
    });
  }
}
